export default {
  background:
    'linear-gradient(92deg, rgb(72, 72, 72) 0%, rgb(103, 103, 103) 100%)',
};
